const OUR_STORY_CDN = 'https://neoterra-site.b-cdn.net/our%20story';

export const ourStoryHeroShot = `${OUR_STORY_CDN}/shot%201.png`;
export const ourStoryAboutShot = `${OUR_STORY_CDN}/shot%202.png`;
export const ourStoryGlassShot = `${OUR_STORY_CDN}/shot%203.png`;
export const founderCarousel1 = `${OUR_STORY_CDN}/founder-carousel-001.webp`;
export const founderCarousel2 = `${OUR_STORY_CDN}/founder-carousel-002.webp`;
